export default __webpack_public_path__ + "static/media/templates-menu.86510023.svg";